import { jsx } from 'react/jsx-runtime';
import { Spinner } from '../Spinner/Spinner.js';
import style from './SpinnerCenter.module.css.js';

const SpinnerCenter = () => (jsx("div", { className: style.container, children: jsx(Spinner, {}) }));

export { SpinnerCenter };
//# sourceMappingURL=SpinnerCenter.js.map
